export default "__VITE_ASSET__CZo_DjiL__"